export default function ToolFrame({src, title, onClose}) {
  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,zIndex:500,display:"flex",flexDirection:"column",background:"#0a0c12"}}>
      <div style={{padding:"8px 16px",borderBottom:"1px solid #252839",display:"flex",alignItems:"center",gap:10,background:"#13161f",flexShrink:0,height:44}}>
        <button style={{background:"none",border:"none",color:"#7a7f9a",fontSize:18,cursor:"pointer",padding:"0 8px 0 0",lineHeight:1}} onClick={onClose}>←</button>
        <span style={{fontSize:14,fontWeight:700,color:"#f5a623",letterSpacing:0.5}}>{title}</span>
        <a href={src} target="_blank" rel="noopener noreferrer" style={{marginLeft:"auto",fontSize:11,color:"#5a6080",textDecoration:"none"}}>Open in new tab ↗</a>
      </div>
      <iframe src={src} style={{flex:1,border:"none",width:"100%",height:"100%"}} title={title} allow="geolocation"/>
    </div>
  );
}
